export const getProductionVariables = () => ({
    authServiceUrl: 'https://iam.viafoura.co',
    cookieDomain: 'viafoura.co',
    adminUrl: 'https://admin.viafoura.co/oauth2/code',
    forgotPasswordForm: 'https://admin.viafoura.co/admin/0/0/login/forgot_password',
    adminEntryUrl: 'admin.viafoura.co',
    consoleUrl: 'https://console.viafoura.co',
    mfaIssuer: 'Viafoura',
    heimdallUrl: 'https://auth.viafoura.co',
});
